angular.module('services')
	.factory('formsStore', ['apiSrv', function(apiSrv) {
		function verifyAccessCode(params) {
			return apiSrv.call(this, 'verify_access_code', {
				method: 'POST',
				params: params
			});
		}

		return {
			verifyAccessCode
		};
	}]);
